import create from 'zustand'
import { persist } from 'zustand/middleware'
import { PatientDataStore } from './types'
import { PatientData } from '@/services/ActivationService/types'

export const usePatientDataStore = create<PatientDataStore>()(
  persist(
    (set, get) => {
      return {
        patientData: null,
        setPatientData: (patientData: Partial<PatientData>) => {
          set({
            patientData: {
              ...get().patientData,
              ...patientData,
            },
          })
        },
      }
    },
    {
      name: 'patientData',
      getStorage: () => sessionStorage,
    },
  ),
)
